// Testimonials Data
const testimonialsData = {
  badgeText: 'Testimonials',
  titles: [
    {
      title: 'What Our',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' Clients Say',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'Hear from our satisfied customers about their experience with ',
      highlight: false,
    },
    {
      content: 'Subul Contracting',
      highlight: true,
    },
    {
      content: ' HVAC services. Their trust and satisfaction drive our commitment to excellence.',
      highlight: false,
    },
  ],
  testimonials: [
    {
      name: 'Ahmed Al-Rashid',
      position: 'Facility Manager, Medical Center',
      rating: 5,
      review: 'Exceptional HVAC service! The team was professional, efficient, and delivered exactly what they promised. Our medical facility now has perfect climate control.',
    },
    {
      name: 'Fatima Al-Zahra',
      position: 'Operations Director, Office Complex',
      rating: 4,
      review: 'Subul Contracting transformed our office environment. The installation was seamless and their maintenance service keeps everything running smoothly.',
    },
    {
      name: 'Mohammad Ibrahim',
      position: 'Plant Manager, Manufacturing',
      rating: 5,
      review: 'Outstanding industrial HVAC solutions. They understood our specific requirements and delivered a system that improved our operational efficiency significantly.',
    },
    {
      name: 'Amal Al-Mansouri',
      position: 'Restaurant Owner',
      rating: 5,
      review: 'Perfect kitchen ventilation system! The team was knowledgeable about restaurant requirements and provided excellent ongoing support.',
    },
    {
      name: 'Omar Al-Fahad',
      position: 'Residential Client',
      rating: 4,
      review: 'Best HVAC service in the region. Professional installation, fair pricing, and excellent customer service. Highly recommend for any HVAC needs.',
    },
  ],
};

// Process Data
const processData = {
  badgeText: 'Our Process',
  titles: [
    {
      title: 'How We',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' Work',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'Our systematic approach ensures ',
      highlight: false,
    },
    {
      content: 'quality results',
      highlight: true,
    },
    {
      content: ' and customer satisfaction in every HVAC project we undertake.',
      highlight: false,
    },
  ],
  steps: [
    {
      stepNumber: '1',
      icon: 'phone',
      title: 'Initial Consultation',
      description: 'We start with understanding your specific HVAC needs through detailed consultation and site assessment.',
    },
    {
      stepNumber: '2',
      icon: 'clipboard',
      title: 'Custom Design',
      description: 'Our experts create a tailored HVAC solution design that meets your requirements and budget.',
    },
    {
      stepNumber: '3',
      icon: 'tool',
      title: 'Professional Installation',
      description: 'Our certified technicians ensure precise installation with minimal disruption to your operations.',
    },
    {
      stepNumber: '4',
      icon: 'check',
      title: 'Testing & Maintenance',
      description: 'We thoroughly test the system and provide ongoing maintenance to ensure optimal performance.',
    },
  ],
};

// Why Choose Us Data
const whyChooseUsData = {
  badgeText: 'Why Choose Us',
  titles: [
    {
      title: 'Your Trusted',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' HVAC Partner',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'With over ',
      highlight: false,
    },
    {
      content: '12 years of experience',
      highlight: true,
    },
    {
      content: ' in the HVAC industry, we provide reliable, efficient, and cost-effective solutions that exceed expectations.',
      highlight: false,
    },
  ],
  keyPoints: [
    {
      title: 'Certified Professionals',
      description: 'Our team consists of licensed and certified HVAC technicians with extensive experience.',
    },
    {
      title: '24/7 Emergency Service',
      description: 'Round-the-clock support for urgent HVAC issues to minimize downtime.',
    },
    {
      title: 'Quality Guarantee',
      description: 'We stand behind our work with comprehensive warranties and satisfaction guarantees.',
    },
  ],
  features: [
    {
      icon: 'award',
      title: 'Industry Expertise',
      description: 'Specialized knowledge in commercial, industrial, and residential HVAC systems.',
    },
    {
      icon: 'clock',
      title: 'Timely Delivery',
      description: 'Committed to completing projects on schedule without compromising quality.',
    },
    {
      icon: 'dollar-sign',
      title: 'Cost-Effective Solutions',
      description: 'Competitive pricing with transparent quotes and no hidden costs.',
    },
  ],
};

// Stats Data
const statsData = {
  badgeText: 'Our Achievements',
  titles: [
    {
      title: 'Numbers That',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' Speak Success',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'Over ',
      highlight: false,
    },
    {
      content: 'a decade of excellence',
      highlight: true,
    },
    {
      content: ' in the HVAC industry, serving clients across various sectors with dedication and expertise.',
      highlight: false,
    },
  ],
  stats: [
    {
      icon: 'users',
      value: '500',
      suffix: '+',
      title: 'Happy Clients',
      description: 'Satisfied customers across different sectors',
    },
    {
      icon: 'briefcase',
      value: '1200',
      suffix: '+',
      title: 'Projects Completed',
      description: 'Successful HVAC installations and maintenance',
    },
    {
      icon: 'calendar',
      value: '12',
      suffix: '+',
      title: 'Years Experience',
      description: 'Established expertise in HVAC solutions',
    },
    {
      icon: 'thumbs-up',
      value: '99',
      suffix: '%',
      title: 'Success Rate',
      description: 'Client satisfaction and project success',
    },
  ],
  achievements: {
    title: 'Our Certifications & Partnerships',
    items: [
      { icon: 'check-circle', title: 'ISO Certified' },
      { icon: 'shield', title: 'Licensed Contractor' },
      { icon: 'star', title: 'Premium Partner' },
      { icon: 'award', title: 'Industry Leader' },
      { icon: 'zap', title: 'Energy Efficient' },
      { icon: 'globe', title: 'Eco-Friendly' },
    ],
  },
};

// CTA Section Data
const ctaSectionData = {
  titles: [
    {
      title: 'Ready to Transform Your',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' Indoor Environment?',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'Get expert ',
      highlight: false,
    },
    {
      content: 'HVAC solutions',
      highlight: true,
    },
    {
      content: ' tailored to your needs. Contact us today for a free consultation and quote.',
      highlight: false,
    },
  ],
  primaryButton: {
    text: 'Get Free Quote',
    link: '/contact-us',
    icon: 'phone',
  },
  secondaryButton: {
    text: 'View Services',
    link: '/services',
    icon: 'eye',
  },
};

export { testimonialsData, processData, whyChooseUsData, statsData, ctaSectionData };
